// those file are generate by npm run i18n
  export default {
  "user": {
    "subtitle": "สรุปท้ายปี",
    "note": "*สถิติทั้งหมดในการสรุปนี้มาจากวันที่ 2025/12/31"
  },
  "handCard": {
    "text": "{date}\nคุณเล่น NUTS POKER เป็นครั้งแรกในปี 2025"
  },
  "report": {
    "loginTime": "ตั้งแต่นั้นมา NUTS POKER อยู่กับคุณมาเป็นเวลา \n{loginDay}",
    "loginTips": "*วันที่เข้า NUTS POKER ในปี 2025",
    "enjoyTime": "{loginTime}\n เป็นช่วงเวลาที่ผ่อนคลายที่สุดของคุณ! นี่คือเวลาโปรดที่คุณมักจะเปิด NUTS POKER!",
    "firstHandDate": "{first_hand_date}\nคุณเริ่มแฮนด์ไพ่แรกของปีโดยเล่น {first_hand_type}\n{first_hand_cards}"
  },
  "hands": {
    "v1": "ในการเล่น NUTS POKER ปีนี้ คุณเล่นไปทั้งหมด\n{hands}\nความรักในโป๊กเกอร์ของคุณมีมากกว่า \n{percentage} ของผู้เล่น",
    "v2": "ในการเล่น NUTS POKER ปีนี้ คุณเล่นไปทั้งหมด \n{hands}\nขอบคุณที่เป็นส่วนหนึ่งในการเดินทางของเรา!",
    "v3": "ในการเล่น NUTS POKER ปีนี้ คุณเล่นไปทั้งหมด \n{hands}\nNUTS POKER จะพยายามปรับปรุงและมอบประสบการณ์การเล่นที่สนุกสนานยิ่งขึ้นในปีหน้า!"
  },
  "hardTime": {
    "date": "{one_day_hands}\nนี่เป็นวันที่คุณทุ่มเทให้กับ NUTS POKER เต็มที่ที่สุด",
    "hands": "ในวันนั้นคุณเล่นไปถึง \n{one_day_hands_num} {longHands}"
  },
  "favoriteGame": "จากจำนวนแฮนด์ไพ่ทั้งหมดของคุณ\n{handsNum} {hands} เป็นการเล่นในรูปแบบโปรดของคุณคือ {game}",
  "kkWin": {
    "v1": "ในปี 2025 คุณได้รับไพ่ KK เป็นจำนวน\n{all} {longTimes}\nและเอาชนะคู่แข่งด้วยไพ่ KK เป็นจำนวน\n{win} {longTimesTwo}",
    "v2": "ในปีนี้ คุณ All-in\n{all} {threeTimes}\nอัตรา All-in แล้วชนะของคุณ:\n{percentage}\nโป๊กเกอร์เป็นเกมสำหรับคนที่ไม่หวั่นกลัว!"
  },
  "achievement": {
    "spinup": "{spinup_date}\n เป็นวันที่โชคดีที่สุดของคุณ",
    "spinup_2": "ในวันนั้นคุณได้รับตัวคูณ {spinup_ratio} ใน SpinUp แล้วชนะ\n{spinup_reward}",
    "mtt": "{mtt_date}\nถือเป็นไฮไลต์ประจำปีของคุณ",
    "mtt_2": "ในวันนั้น\nคุณได้อันดับ {mtt_rank} ใน {mtt_name}\nและชนะรางวัล\n{mtt_reward}",
    "rg": "{rg_date}\nวันอันน่าจดจำในการเส้นทางโป๊กเกอร์ของคุณ!",
    "rg_2": "คุณชนะรางวัลกองกลางที่ใหญ่ที่สุดในรอบปี:\n{rg_reward}"
  },
  "lucky": {
    "title": "ไพ่ทุกมือล้วนบอกเล่า\nเรื่องราวที่แตกต่างกันไป",
    "luckyHand": "มือไพ่\nโชคดี",
    "unLuckyHand": "มือไพ่\nโชคไม่ดี",
    "luckyRate": "อัตราชนะ\n{lucky_rate}",
    "unLuckyRate": "อัตราชนะ\n{unlucky_rate}",
    "luckyText": "{lucky_hand} ได้เล่นเป็นฮีโร่ \nคุณชนะ {lucky_rate} ตลอดระยะเวลาที่คุณมีมัน!",
    "unLuckyText": "ระวัง {unlucky_hand} ให้ดี…\nคุณชนะเพียง {unlucky_rate} ตลอดระยะเวลาที่คุณมีมัน!",
    "note": "*เฉพาะมือไพ่เริ่มต้นที่แจกไพ่ 10 ครั้งขึ้นไปเท่านั้นที่ผ่านเกณฑ์คุณสมบัติ"
  },
  "futureStory": "NUTS POKER รอไม่ไหวแล้วที่จะได้เขียนเรื่องราวการเดินทางโป๊กเกอร์ของคุณต่อไปในปีต่อไป 2026",
  "version3": {
    "text": "น่าเสียดายที่คุณยังไม่ได้ฝากความทรงจำใดๆ กับ NUTS POKER ในปี 2025",
    "continue": "มาเขียนเรื่องราวบทต่อไปบนเส้นทาง NUTS POKER\nกับเราในปี 2026!",
    "tips": "\n **สถิติทั้งหมดเป็นของวันที่ 2024-12-31"
  },
  "button": {
    "save": "บันทึกรูปภาพ",
    "copy": "คัดลอกแล้วแชร์"
  },
  "unit": {
    "days": "วัน",
    "hands": "แฮนด์ไพ่",
    "longHands": "แฮนด์ไพ่",
    "longTimes": "ครั้ง",
    "longTimesTwo": "ครั้ง",
    "threeTimes": "ครั้ง",
    "times": "ครั้ง",
    "multiplier": "ตัวคูณ ",
    "num": "",
    "num2": "",
    "bets": "เดิมพัน",
    "skUnits": ""
  },
  "toast": {
    "linkCopied": "คัดลอกลิงก์แล้ว",
    "imageSaved": "บันทึกรูปภาพแล้ว"
  }
}
  